import clsx from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
/**
 * Semantic tokens from tokens.css aren't in tailwind-merge's defaults.
 * Without this, `text-caption text-fg-muted` collapses to just the color —
 * size and color both use the `text-*` namespace, so the size is dropped.
 */
const twMerge = extendTailwindMerge({
    extend: {
        theme: {
            text: [
                'heading-3',
                'heading-4',
                'heading-5',
                'heading-6',
                'body',
                'body-lg',
                'body-sm',
                'caption',
                'xxs',
            ],
            shadow: ['card', 'card-hover', 'popover', 'modal', 'focus'],
            radius: [
                'control-sm',
                'control',
                'control-lg',
                'card-sm',
                'card',
                'card-lg',
                'surface',
                'pill',
            ],
            spacing: [
                'stack-dense',
                'stack-tight',
                'stack',
                'stack-roomy',
                'stack-section',
                'stack-grid',
                'stack-hero',
                'prose-tight',
                'prose',
                'prose-roomy',
                'prose-block',
                'container',
            ],
        },
    },
});
export function cn(...args) {
    return twMerge(clsx(...args));
}
